import { Api } from "../config/request";

export default {
  getMenusList() {
    return Api.get("/menu");
  },
  checkMenuActionAllowed(payload) {
    return Api.get(`/menu-action-allowed${payload}`);
  },
};
